<p-toast></p-toast>
<div class="card w-full h-full flex flex-col shadow-sm p-6 rounded-2xl bg-white gap-6">
  <div class="flex flex-col gap-3">
    <div class="flex flex-col gap-2">
      <div class="w-full">
        <span class="font-semibold text-base md:text-2xl">Carga masiva</span>
      </div>
    </div>
  </div>

  <div>
    <p-fileupload
      name="myfile[]"
      [multiple]="false"
      accept=".xls, .xlsx, .csv"
      [customUpload]="true"
      maxFileSize="1000000"
      (onSelect)="onSelectedFiles($event)">

      <ng-template #header let-files let-chooseCallback="chooseCallback" let-clearCallback="clearCallback">
        <div class="flex flex-wrap justify-between items-center flex-1 gap-4">
          <div class="flex gap-2">
            @if (files.length === 0) {
              <app-button
                icon="fi-rr-plus"
                label="Agregar archivo"
                (click)="choose($event, chooseCallback)">
              </app-button>
            }

            @if (files.length > 0) {
              <app-button icon="fi-rr-trash" color="red-500" label="Eliminar"
                          (click)="clearCallback()"></app-button>
            }
          </div>

          @if (files.length > 0) {
            <app-button label="Procesar archivo"
                        icon="fi-rr-check"
                        color="green-500"
                        (click)="processFile()"></app-button>
          }
        </div>
      </ng-template>

      <ng-template #content let-files>
        <div class="flex justify-center items-center pt-6">
          @if (files?.length > 0) {
            <div
              class="w-44 h-44 flex flex-col items-center justify-center
               border-2 border-dashed border-green-400
               rounded-2xl bg-green-50 gap-3 px-3">

              <i class="fi fi-rr-file text-6xl text-green-600"></i>

              <span
                class="text-xs font-medium text-green-700 text-center
                 truncate w-full">
          {{ files[0].name }}
        </span>
            </div>
          }
        </div>
      </ng-template>




      <ng-template #file></ng-template>

      <ng-template #empty>
        <div class="flex items-center justify-center flex-col">
          <i class="fi-rr-upload border-1 rounded-full p-8 text-3xl border-gray-300"></i>
          <p class="mt-6 mb-0">Arrastra y suelta el archivo.</p>
        </div>
      </ng-template>

    </p-fileupload>
  </div>
</div>
